// The server owns the final wording stored in a Factory run reservation. The UI
// imports this same deterministic helper only for non-authoritative previews/tests.
const FACTORY_NOVELTY_FOCUSES = [
  'subject category',
  'scene type',
  'action or stillness',
  'viewpoint and crop',
  'composition and negative space',
  'relationship between visible elements',
  'silhouette or material emphasis',
  'visual rhythm and moment',
] as const;

export const factoryDiversityBriefFor = (slot: number, requestedBrief = ''): string => {
  const index = Math.abs(Math.trunc(slot)) % FACTORY_NOVELTY_FOCUSES.length;
  const focus = FACTORY_NOVELTY_FOCUSES[index]!;
  const authority = requestedBrief.trim()
    ? 'Keep every subject, setting, action, pose, framing, and product explicitly named in the brief unchanged.'
    : 'Choose the subject treatment, setting, action, and framing from the source files only as abstract visual guidance; do not assume a location, person, product, or scene type.';
  return `[Factory novelty lane ${index + 1}/${FACTORY_NOVELTY_FOCUSES.length}]
${authority} For choices the brief leaves open, prioritise a novel ${focus}. Do not reuse a recognizable person, pose, scene, or composition from another Factory output.`;
};
